import { useAuth0 } from '@auth0/auth0-react'
import { useCallback } from 'react'
import Cookies from 'universal-cookie'

import { removeAccessToken } from 'lib/api/utils'
import store from 'lib/store'
import { RESET_STORE } from 'lib/store/rootReducer'
import { setApplicationProperties } from 'domains/application/ducks/application'
import { cancelNotificationListener } from 'domains/notifications/workflows/listenForNotifications'

import trackAuthenticationAnalytics from '../utils/trackAuthenticationAnalytics'
import { VERIFIER_TOKEN } from '../workflows/oauth2Login'

export const useLogout = () => {
  const { logout: auth0logout } = useAuth0()

  const logout = useCallback(() => {
    const cookies = new Cookies()

    cookies.remove(VERIFIER_TOKEN)
    cancelNotificationListener()
    removeAccessToken()
    auth0logout({ logoutParams: { returnTo: window.location.origin } })

    store.dispatch({ type: RESET_STORE })
    store.dispatch(
      setApplicationProperties({
        me: false,
        loggedOut: true,
        initialized: false,
      }),
    )
    trackAuthenticationAnalytics('logged_out')
  }, []) //eslint-disable-line

  return logout
}
